var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm._m(0)
}
var staticRenderFns = [
  function() {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "row bg-white board-radius" }, [
      _c("div", { staticClass: "col-12 col-md-3" }, [
        _c("label", { staticClass: "name-title" }, [
          _vm._v(" Leyenda de Tipo de Disponibilidad: ")
        ])
      ]),
      _c("div", { staticClass: "col-12 col-md-9 d-flex flex-wrap pr-2" }, [
        _c("div", { staticClass: "content-container px-0" }, [
          _c("div", { staticClass: "container-box grupal" }),
          _c("div", { staticClass: "container-label" }, [
            _c("span", [_vm._v("Estudiante")]),
            _c("span", [_vm._v("Modalidad Grupal")])
          ])
        ]),
        _c("div", { staticClass: "content-container px-0" }, [
          _c("div", { staticClass: "container-box individual" }),
          _c("div", { staticClass: "container-label" }, [
            _c("span", [_vm._v("Estudiante")]),
            _c("span", [_vm._v("Modalidad Individual")])
          ])
        ]),
        _c("div", { staticClass: "content-container px-0" }, [
          _c("div", { staticClass: "container-box available-space" }),
          _c("div", { staticClass: "container-label" }, [
            _c("span", [_vm._v("Espacio Disponible")])
          ])
        ]),
        _c("div", { staticClass: "content-container px-0" }, [
          _c("div", { staticClass: "container-box not-available-space" }),
          _c("div", { staticClass: "container-label" }, [
            _c("span", [_vm._v("Espacio No Disponible")])
          ])
        ]),
        _c("div", { staticClass: "content-container px-0" }, [
          _c("div", { staticClass: "container-box grupal-inside" }),
          _c("div", { staticClass: "container-label" }, [
            _c("span", [_vm._v("Horario Reservado Grupal")]),
            _c("span", [_vm._v("dentro de la Corporación")])
          ])
        ]),
        _c("div", { staticClass: "content-container px-0" }, [
          _c("div", { staticClass: "container-box individual-inside" }),
          _c("div", { staticClass: "container-label" }, [
            _c("span", [_vm._v("Horario Reservado Individual")]),
            _c("span", [_vm._v("dentro de la Corporación")])
          ])
        ]),
        _c("div", { staticClass: "content-container px-0" }, [
          _c("div", { staticClass: "container-box busy-outside" }),
          _c("div", { staticClass: "container-label" }, [
            _c("span", [_vm._v("Horario Ocupado")]),
            _c("span", [_vm._v("Fuera de Corporación")])
          ])
        ]),
        _c("div", { staticClass: "content-container px-0" }, [
          _c("div", { staticClass: "container-box expired-license" }, [
            _c("i", {
              staticClass:
                "fa fa-calendar-exclamation specialist-license-expired-icon"
            })
          ]),
          _c("div", { staticClass: "container-label" }, [
            _c("span", [_vm._v("Especialista con Licencia")]),
            _c("span", [_vm._v("Vencida")])
          ])
        ]),
        _c("div", { staticClass: "content-container px-0" }, [
          _c("div", { staticClass: "container-box changeInService" }),
          _c("div", { staticClass: "container-label" }, [
            _c("span", [_vm._v("Estudiante")]),
            _c("span", [_vm._v("con Cambio en Servicio")])
          ])
        ]),
        _c("div", { staticClass: "content-container px-0" }, [
          _c("div", { staticClass: "container-box practitioner" }),
          _c("div", { staticClass: "container-label" }, [
            _c("span", [_vm._v("Estudiante")]),
            _c("span", [_vm._v("con practicante/interno")])
          ])
        ])
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }